import { render, staticRenderFns } from "./slidelogo.vue?vue&type=template&id=4537f26c&scoped=true&"
import script from "./slidelogo.vue?vue&type=script&lang=js&"
export * from "./slidelogo.vue?vue&type=script&lang=js&"
import style0 from "./slidelogo.vue?vue&type=style&index=0&id=4537f26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537f26c",
  null
  
)

export default component.exports